module.exports = __webpack_public_path__ + "static/media/img_patient_no-action.1d410fa9.svg";